/**
 * Unified post-auth route resolver.
 *
 * Prefers the backend-provided `next_route` hint (from /api/auth/session and
 * /api/auth/me). Falls back to client-side role logic for resilience if the
 * backend hint is missing (e.g. older cached responses, transient failures).
 *
 * Ticket AUTH.2 — Unified Login Foundation.
 */

export function routeByRole(user) {
  if (!user) return '/';

  // 1. Prefer backend hint.
  if (typeof user.next_route === 'string' && user.next_route.startsWith('/')) {
    return user.next_route;
  }

  // 2. Fallback: client-side mirror of backend compute_next_route().
  const role = (user.role || 'parent').toLowerCase();
  const isPlatformAdmin = Boolean(user.is_platform_admin);

  if (role === 'platform_admin' && isPlatformAdmin) return '/platform-admin';
  if (role === 'school_admin') return '/school-admin';
  if (role === 'teacher') return '/school-teacher';

  if (role === 'student' || user.is_student_account) {
    return user.child_id ? `/child/${user.child_id}/home` : '/student/onboarding';
  }

  // Parent (default)
  // School parents (B2B observer accounts) land on the school-parent
  // dashboard. Distinct from B2C consumer parents who go to /family.
  if (role === 'parent' && user.is_school_parent) return '/school-parent';
  if (!user.has_pin) return '/set-pin';
  return '/family';
}

export default routeByRole;
